import branchAPI from '../../api/Branch'
import * as types from '../mutation-types'

// STATE
const state = {
    Branch: {
        Brands: []
    },
    BranchOptions: []
}

// GETTERS
const getters = {
    Branch: state => state.Branch,
    BranchOptions: state => state.BranchOptions
}

// ACTIONS
const actions = {
    getBranchOptions({ commit }, params) {
        return new Promise((resolve, reject) => {
            branchAPI.getBranchOptions(branchOptions => {
                commit(types.RECEIVE_BRANCH_OPTIONS, { branchOptions })
                resolve()
            }, params)
        })
    },
    getBranch({ commit }, id) {
        return new Promise((resolve, reject) => {
            branchAPI.getBranch(branch => {
                commit(types.RECEIVE_BRANCH, { branch })
                resolve()
            }, id)
        })
    },
    updateBranch({ commit }, params) {
        return new Promise((resolve, reject) => {
            branchAPI.updateBranch(banner => {
                resolve(banner)
            }, params)
        })
    }
}

// MUTATIONS
const mutations = {
    [types.RECEIVE_BRANCH_OPTIONS] (state, { branchOptions }) {
        state.BranchOptions = branchOptions
    },
    [types.RECEIVE_BRANCH] (state, { branch }) {        
        state.Branch = branch
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
  


// WEBPACK FOOTER //
// ./src/store/modules/Branch.js